module.exports = __webpack_public_path__ + "static/media/33.aba4ae98.jpg";